import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime, formatUnit } from "@/common/utils/formatters";
import { MaintenanceForwardingEstablishmentChoiceEntryKlass } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/privateCompanies/pages/Maintenance/Workflows/Show/features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../../../../../../../constants/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { useForwardingTabContext } from "../../../../../../../hooks/forwardings/useForwardingTabContext";

export interface MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntryProps { }

const MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntry = ({

}: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntryProps) => {
  const { forwarding, directiveEntryKlass } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass,
    MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry
  >();

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center gap-2 justify-between">
        <div>
          <p className="text-lg font-semibold">
            Leilão ({directiveEntryKlass && maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass]?.label})
          </p>

          <p className="text-warning text-xs">
            Aguardando início
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding?.establishment_choice_entry?.kind && (
            <ResumeItem
              label="Tipo de leilão"
              value="Aberto"
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding?.establishment_choice_entry?.allowance_radius_in_kilometers && (
            <ResumeItem
              label="Raio de exibição do leilão"
              value={formatUnit(parseInt(forwarding?.establishment_choice_entry?.allowance_radius_in_kilometers), 'kilometers')}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        <div className="flex gap-3">
          <ResumeItem
            label="Início do leilão programado"
            value={forwarding?.establishment_choice_entry?.start_at
              ? formatDateTime(new Date(forwarding?.establishment_choice_entry?.start_at))
              : '--'}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />

          <ResumeItem
            label="Encerramento do leilão programado"
            value={forwarding?.establishment_choice_entry?.finish_at
              ? formatDateTime(new Date(forwarding?.establishment_choice_entry?.finish_at))
              : '--'}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />
        </div>
      </div>
    </Box>
  )
}

export default MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntry;
